import { useFetchPage } from "~/core/composables/useFetchPage";
import { useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import type { UseFetchResponse } from "~/core/models/UseFetchResponse.interface";
import operationManagerService from "~/core/services/operationManager.service";
import type { DtwinOperation } from "~/modules/dtwin/models/DtwinOperation.interface";
import type { FiltersSelection } from "~/types";
import {
  Filters,
  FiltersType,
  OPERATOR_RSQL_EQUAL,
  OPERATOR_RSQL_IN,
} from "~/types";

export function useFetchDtwinOperations({
  searchMode,
  useQueryParametersForPagination,
  defaultSort,
  organizationCode,
}: UseFetchParameters): UseFetchResponse<
  DtwinOperation<Record<string, string>>
> {
  const service = operationManagerService.getOperations.bind(
    operationManagerService,
  );

  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.DTWIN_OPERATION_UID,
      { key: "deviceTwinUid", operator: OPERATOR_RSQL_EQUAL, value: [] },
    ],
    [
      Filters.DTWIN_OPERATION_TYPE,
      { key: "type", operator: OPERATOR_RSQL_IN, value: [] },
    ],
    [
      Filters.DTWIN_CREATED_IN_CAMPAIGN,
      { key: "createdInCampaign", operator: OPERATOR_RSQL_EQUAL, value: "" },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    searchMode,
  );
  const { sort, onSortChange } = useSort();
  sort.value = defaultSort;
  const { isLoading, results, error, fetchData } = useFetchPage({
    service,
    searchParams,
    sort,
    useQueryParametersForPagination,
    organizationCode,
    sortOverrideCallback: search,
  });

  return {
    error,
    fetchData,
    filters,
    isLoading,
    onSearch,
    onSortChange,
    results,
    search,
    setFilter,
    sort,
  };
}
